import React from 'react';
import { WrapperProjects, ProjectDiv } from './style';
import { handleDeleteProject } from '../../../functions/SincronizaNFe/handleDeleteProject';

export default function ListProjects({
  projects,
  setProjects,
  setTotalRateio,
  setTotalValueStatus,
  setTotalValueCnpj1,
  totalValueCnpj1,
  setTotalValueCnpj2,
  totalValueCnpj2,
}) {
  return (
    <WrapperProjects>
      {projects &&
        projects.map((project, index) => {
          return (
            <ProjectDiv key={`project-${index + 1}`}>
              <h3>{project.clientAndProject}</h3>
              <div>
                <p>{project.rateio}%</p>
                <p>{project.value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
                <button
                  onClick={() =>
                    handleDeleteProject(
                      index,
                      project.value,
                      project.rateio,
                      project.cnpj,
                      projects,
                      setProjects,
                      setTotalRateio,
                      setTotalValueStatus,
                      setTotalValueCnpj1,
                      totalValueCnpj1,
                      setTotalValueCnpj2,
                      totalValueCnpj2,
                    )
                  }
                >
                  Apagar
                </button>
              </div>
            </ProjectDiv>
          );
        })}
    </WrapperProjects>
  );
}
